<template>
  <div class="datafilter">
    <form v-on:submit.prevent="search">
      <DataInput label="freeText" width="40%" v-model="taskFilter.freeText" />
      <DataInput label="start" width="5%" v-model="taskFilter.start" />
      <DataInput label="size" width="5%" v-model="taskFilter.size" />
      <DataInput label="sort" width="20%" v-model="taskFilter.sort" />
      <button type="submit">Search</button>
      <button @click="toggleHelp" :style="{ color: 'blue' }">ℹ</button>
      <span>Found {{ taskFilterCount }}</span>
    </form>
    <div v-if="showHelp">
      <span>
        ElasticSearch fields usable in
        <strong>freeText</strong>
        with
        <a
          target="_blank"
          href="https://www.elastic.co/guide/en/elasticsearch/reference/5.5/query-dsl-query-string-query.html#query-string-syntax"
        >
          Query string syntax
        </a>
        . The same fields are usable for
        <strong>sort</strong>
        possible Order are
        <a
          target="_blank"
          href="https://static.javadoc.io/org.elasticsearch/elasticsearch/5.0.0/org/elasticsearch/search/sort/SortOrder.html"
        >
          DESC and ASC
        </a>
        . If you have several sort you must separate them with
        <strong>|</strong>
        .
      </span>
      <ul>
        <li>correlationId-keyword</li>
        <li>endTime-date</li>
        <li>executionTime-long</li>
        <li>externalInputPayloadStoragePath-text</li>
        <li>externalOutputPayloadStoragePath-text</li>
        <li>input-text</li>
        <li>output-text</li>
        <li>queueWaitTime-long</li>
        <li>reasonForIncompletion-keyword</li>
        <li>scheduledTime-date</li>
        <li>startTime-date</li>
        <li>status-keyword</li>
        <li>taskDefName-keyword</li>
        <li>taskId-keyword</li>
        <li>updateTime-date</li>
        <li>workflowId-keyword</li>
        <li>workflowType-keyword</li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import DataInput from '@/components/DataInput.vue'

export default {
  name: 'TaskFilter',
  data() {
    return {
      showHelp: false
    }
  },
  computed: mapState({
    taskFilter: state => Object.assign({}, state.taskFilter),
    taskFilterCount: state => state.taskFilterCount
  }),
  methods: {
    ...mapActions(['getTasks']),
    ...mapMutations(['setTaskFilter']),
    search() {
      this.setTaskFilter(this.taskFilter)
      this.getTasks()
    },
    toggleHelp() {
      this.showHelp = !this.showHelp
    }
  },
  components: {
    DataInput
  }
}
</script>
